export const NEXTGEN_MAX_CONTENT_WIDTH = 1200;

/**
 * For a page whose content is a wide table rather than prose and cards. The evals
 * configuration columns measure ~1270px before anything truncates, which the
 * standard column would put a horizontal scrollbar under.
 */
export const NEXTGEN_WIDE_CONTENT_WIDTH = 1440;
